(() => {
  const language = document.documentElement.lang;
  const domainParts = window.location.hostname.split('.');
  const domain = `.${domainParts.filter((part) => part !== 'www' && part !== language).join('.')}`;

  window.swinger = {
    ...window.swinger,
    cookie: {
      remove: (key) => {
        if (!window.swinger.cookie.get(key)) {
          return;
        }
        document.cookie = `${key}=;path=/${!window.location.hostname.startsWith('localhost') && !window.location.hostname.endsWith(':3000') ? `;domain=${domain}` : ''};max-age=-99999999`;
      },
      get: (key) => document.cookie.split('; ').reduce((result, entry) => {
        const [entryKey, entryValue] = entry.split('=');
        return entryKey === key ? entryValue : result;
      }, null),
      set: (key, value, expires = 31536000) => {
        window.swinger.cookie.remove(key);
        document.cookie = `${key}=${value};path=/${!window.location.hostname.startsWith('localhost') && !window.location.hostname.endsWith(':3000') ? `;domain=${domain}` : ''};max-age=${expires}`;
      },
    },
  };
})();
